import { defineComponent as _defineComponent } from 'vue'
import { getPointsLog } from '@/api/points/log';
import moment from 'moment';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PointsDetail',
  props: {
    user_id: null
  },
  setup(__props: any) {

const props = __props as { user_id: string };

function dateFormat(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}


const dataSource = ref();
const pagination = ref<any>({
  current: 1,
  total: 0,
  pageSize: 20,
});

async function init(id, current) {
  const res = await getPointsLog(id, current);
  if (!res) {
    return;
  }
  dataSource.value = res?.detail;
  pagination.value = {
    current: +res.current || 0,
    total: res.total || 0,
    pageSize: res.limit || 0,
    showTotal: () => `共${res.total}条，每页${res.limit}条`,
  };
}
function handleChange(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  init(props.user_id, page.current);
}
init(props.user_id, 1);

return { __sfc: true,dateFormat, props, dataSource, pagination, init, handleChange }
}

})